import FudopiaStory from "../assets/why fudopia.webp";

function WhyFudopia() {
  return (
    <div className="section why-fudopia">
      <div className="text-column">
        <h2>Why We Created Fudopia</h2>
        <p>
          Honestly, it all started with the amazing foods we’ve tried around the
          world. We thought, we’re already living in a Fudopia. But could we
          make it even better by sharing those meals with others? By reminding
          ourselves how much we all have in common?
        </p>
        <p>
          A plate of noodles, a cup of tea, a dish you can’t even pronounce,
          these simple things can spark conversations that make the world feel
          smaller, more connected, and so much more delicious.
        </p>
        <p>
          Our goal is to help people step out of their bubble, try something
          new, and see where it leads. We started in Bangkok, but we won’t stop
          there. One table of four at a time, we’re building a community fueled
          by curiosity and really good food.
        </p>
      </div>
      <div className="image-column">
        <img
          src={FudopiaStory}
          alt="Illustration of a cozy table with dishes from around the world"
        />
      </div>
    </div>
  );
}

export default WhyFudopia;
